import React from "react";
import {
    Typography,
    Stack,
    Alert,
    Paper,
} from "@mui/material";

import { ClearCallLogoTitle } from "../../components/clear-call-logo";
import Copyright from "../../components/copyright";
import { Message } from "../../store";

interface MeetingTimeErrorPageProps {
    message: Message
}

const MeetingTimeErrorPage: React.FC<MeetingTimeErrorPageProps> = ({
    message
}) => {

    return (
        <Stack
            justifyContent={"center"}
            justifyItems={"center"}
            alignContent={"center"}
            alignItems={"center"}
            spacing={1}
            sx={{
                minHeight: "100vh",
                background: "linear-gradient(0deg,rgb(222, 238, 253),rgb(172, 220, 226))",
            }}>

            <Paper>
                <Stack
                    alignItems={"center"}
                    width={"400px"}
                    spacing={3}
                    padding={1}>
                    <Stack width={"fit-content"}>
                        <ClearCallLogoTitle size={100} />
                    </Stack>
                    <Typography variant="h4" component="h1" textAlign="center">
                        Proposed Meeting Times
                    </Typography>
                    <Stack spacing={2} sx={{ mt: 2, width: "100%" }}>
                        <Alert severity={message.type}>{message.message}</Alert>
                    </Stack>
                </Stack>
            </Paper>
            <Copyright sx={{ mt: 5 }} />
        </Stack>
    );
};

export default MeetingTimeErrorPage;
